module.exports = __webpack_public_path__ + "static/media/dragons.409d91c5.png";